import { gql } from '@apollo/client'

/**
 * Query to get User data
 * @category User
 */
export const GET_USER = gql`
  query get_user($id: String!) {
    users_by_pk(id: $id) {
      id
      name
      email
      picture
      phone
      customer {
        id
        title
        features
        customer_roles {
          user_id
          role
        }
      }
      supplier {
        id
        title
      }
    }
    user_roles(where: { user_id: { _eq: $id } }) {
      role {
        role_permissions {
          permission {
            title
          }
        }
      }
    }
  }
`

/**
 * Query to get all users by a custom where clause
 * @category User
 */
export const GET_USERS_BY_CUSTOM_FILTERS = gql`
  query usersByCustomFilters($where: users_bool_exp) {
    users(where: $where) {
      id
      name
      email
      picture
    }
  }
`
